/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

declare global {
  interface Window {
    __gtmId__?: string;
  }
}

window.__gtmId__ = environment.googleTagManagerId;

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
